import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'

const linkColorClass = (color: 'default' | 'orange' | 'purple' | 'red' | 'green'): string => {
  switch (color) {
    case 'default':
      return 'hover:bg-secondary-hover'
    case 'orange':
      return 'hover:bg-fill-tsuki'
    case 'purple':
      return 'hover:bg-fill-fuji'
    case 'red':
      return 'hover:bg-fill-beni'
    case 'green':
      return 'hover:bg-fill-take'
  }
}

interface SummaryCellProps extends ChildProps {
  link?: string
  vertical?: boolean
  color?: 'default' | 'orange' | 'purple' | 'red' | 'green'
  noFull?: boolean
}

const SummaryCell = ({ children, link, vertical, color = 'default' }: SummaryCellProps) => {
  const Tag = link ? 'a' : 'div'
  return (
    <Tag
      href={link}
      className={clsx(
        'bg-surface-secondary relative flex min-h-13.75 flex-1 gap-1.5 rounded-lg px-4 py-2 transition duration-300 ease-in-out',
        vertical && 'flex-col',
        link && 'cursor-pointer',
        link && linkColorClass(color)
      )}
    >
      {children}
      {link && (
        <span className='absolute top-[50%] right-4 -translate-y-1/2'>
          <Icon type={IconType.ARROW_RIGHT} color={IconColor.LINK} />
        </span>
      )}
    </Tag>
  )
}
export default SummaryCell
